import Api from './Api'

export default {
    async show(parameters) {
        const api = await Api()
        return api.post('users', parameters)
    },
    async delete(parameters) {
        const api = await Api()
        return api.post('user/delete', parameters)
    },
    async showEnvironments(parameters) {
        const api = await Api()
        return api.post('org/environments', parameters)
    },
    async create(parameters) {
        const api = await Api()
        return api.post('new-user', parameters)
    },
    async showUserEnvironments(parameters) {
        const api = await Api()
        return api.post('user/environments', parameters)
    },
    async update(parameters) {
        const api = await Api()
        return api.post('user/update', parameters)
    },
    async updateStatus(parameters) {
        const api = await Api()
        return api.post('user/update-status', parameters)
    },
    async clearPassword(parameters) {
        const api = await Api()
        return api.post('clear-password', parameters)
    },
    async getUserInfo(parameters) {
        const api = await Api()
        return api.post('user', parameters)
    }
}